import React from 'react';
import { generate_use_form_schema } from '../../../../steps/formStep';
import Form from '../../misc/form/form';
import useForm from '../../../../utils/useForm';
import CheckboxCard from '../../cards/checkboxCard/checkboxCard';


export function InvoiceRequest({config, setInvoiceFormToSubmit}) {
    const { invoice_request_toggle } = config;
    const form = config.form.invoice.form_invoice;
    const title = config.form.invoice.header.title;
    const [displayInvoiceForm, setDisplayInvoiceForm] = React.useState(invoice_request_toggle === null);

    let invoiceFormSchema = React.useRef(generate_use_form_schema(form.fields));
    const [_form, setFormValue, setFormObject] = useForm(invoiceFormSchema.current, {
        onChange: (formData) => setInvoiceFormToSubmit(formData)
    });

    const onToggle = React.useCallback((e, { checked }) => {
        setDisplayInvoiceForm(checked);
        if (checked) {
            setInvoiceFormToSubmit(_form);
        } else {
            setInvoiceFormToSubmit(null);
        }
    }, [_form]);

    return (
        <>
            {invoice_request_toggle !== null && (
                <>
                    <h1 className='neo-form-step-title'>{title}</h1>
                    <CheckboxCard required={false} onChange={onToggle} title={invoice_request_toggle.title} description={invoice_request_toggle.subtitle} />
                </>
            )}
            {((invoice_request_toggle !== null && displayInvoiceForm) || invoice_request_toggle === null) && (
                <>
                    <Form
                        form={_form}
                        setFormValue={setFormValue}
                        setFormObject={setFormObject}
                        fields={form.fields}
                        formIndex="invoice_request"
                    />
                </>
            )}
        </>
    );
}